import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el material después de comprar?',
  a: 'En menos de 5 minutos recibís un mail con el link de descarga directo. Si no llega, revisá SPAM o escribinos a soporte@impulsodigitalstore.com'
}, {
  q: '¿Necesito experiencia previa en cocina?',
  a: 'Para nada. Cada receta tiene el paso a paso desde cero. Si podés seguir instrucciones, podés hacer estas recetas sin problema.'
}, {
  q: '¿Es un pago único o una suscripción?',
  a: 'Pago único. Sin mensualidades, sin renovaciones, sin cobros ocultos. Pagás una vez y el acceso es tuyo para siempre.'
}, {
  q: '¿La garantía es real?',
  a: '100% real. Escribís a soporte@impulsodigitalstore.com dentro de los 7 días y te devolvemos todo. Sin preguntas.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 px-4 bg-brand-base border-t border-brand-gold/15 relative overflow-hidden" data-id="element-91">
      <div className="absolute inset-0 grain pointer-events-none" data-id="element-92"></div>
      <div className="absolute top-10 left-1/2 -translate-x-1/2 w-[400px] h-[200px] bg-brand-gold/10 blur-3xl rounded-full pointer-events-none" data-id="element-93"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-94">
        <div className="mb-12 text-center" data-id="element-95">
          <h2 className="font-display text-3xl sm:text-4xl font-extrabold text-brand-gold flex items-center justify-center gap-3 glow-gold tracking-tight" data-id="element-96">
            ❓ LO QUE MÁS NOS PREGUNTAN
          </h2>
        </div>

        <div className="space-y-4" data-id="element-97">
          {faqs.map((faq, i) => <div key={i} className="bg-brand-ink/70 backdrop-blur-sm rounded-xl overflow-hidden border border-brand-gold/25" style={{
          boxShadow: '0 10px 30px -10px rgba(0,0,0,0.5), inset 0 1px 0 rgba(212,168,67,0.08)'
        }} data-id="element-98">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-99">
                <span className="font-bold text-base sm:text-lg text-brand-gold pr-4 glow-gold flex items-start gap-2" data-id="element-100">
                  <span className="text-brand-gold mt-0.5" data-id="element-101">✦</span>
                  <span data-id="element-102">{faq.q}</span>
                </span>
                <motion.div animate={{
              rotate: openIndex === i ? 180 : 0
            }} transition={{
              duration: 0.2
            }} className="shrink-0 text-brand-gold" data-id="element-103">
                  <ChevronDown size={22} data-id="element-104" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-105">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-106">
                    <div className="px-6 pb-6 text-brand-cream/85 leading-relaxed text-left text-sm sm:text-base border-t border-brand-gold/15 pt-4" data-id="element-107">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}